module.exports = "/content/2f4400642c3fa5c078142a8f437e806a.png";